import request from '@/utils/request'

export function getRecommendPersonList(params = {}) {
  return request.get('/asset/admin/recommend/persons', params)
}

export function saveRecommendPerson(data) {
  return request.post('/asset/admin/recommend/persons/save', data)
}
